<template>
  <div id="page-add-supplier">
    <vs-card>
      <div class="vx-row pt-5 px-5">
        <div class="vx-col w-full md:w-1/2 px-8">
          <!-- Col Content -->
          <div class="vx-row mb-1">
            <label for="">Username <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-user" v-model="form.username" icon-pack="feather" class="w-full mb-1" name="User Name" v-validate="'required|alpha_dash'" />
            <span class="text-danger text-sm" v-show="errors.has('User Name')">{{ errors.first('User Name') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">First Name <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-user" v-model="form.firstname" icon-pack="feather" class="w-full mb-1" name="First Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Last Name <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-user" v-model="form.lastname" icon-pack="feather" class="w-full mb-1" name="Last Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Mobile <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-phone" v-model="form.mobile" icon-pack="feather" class="w-full mb-1" name="Mobile" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Business Name</label>
            <vs-input icon="icon icon-home" v-model="form.business_name" icon-pack="feather" class="w-full mb-1" name="Business Name" />
            <span class="text-danger text-sm" v-show="errors.has('Business Name')">{{ errors.first('Business Name') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Address</label>
            <vs-input icon="icon icon-map-pin" v-model="form.address" icon-pack="feather" class="w-full mb-1" name="Address" />
            <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label>City</label>
            <select-2
              :ssr="false"
              class="w-full"
              :value="form.cityId"
              @input="(item) => (form.cityId = item && item.value)"
              label-placeholder="City"
              name="City"
              placeholder="Select City"
              action="getCityOptions"
            />
          </div>

          <!-- metrc api key -->
          <div class="vx-row mb-1">
            <label for="">Metrc API key</label>
            <vs-input v-validate="'alpha_dash'" icon-pack="feather" icon="icon-user" data-vv-validate-on="blur" name="metrcKey" v-model="form.metrcKey" class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('metrcKey')">{{ errors.first('metrcKey') }}</span>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2 px-8">
          <div class="vx-row mb-1">
            <label for="">State</label>
            <vs-input icon="icon icon-map-pin" v-model="form.state" icon-pack="feather" class="w-full mb-1" name="State" />
            <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Zipcode</label>
            <vs-input icon="icon icon-map-pin" v-model="form.zipcode" icon-pack="feather" class="w-full mb-1" name="Zip Code" />
            <span class="text-danger text-sm" v-show="errors.has('Zip Code')">{{ errors.first('Zip Code') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Omma license number</label>
            <vs-input icon="icon icon-map-pin" v-model="form.omma_license_number" icon-pack="feather" class="w-full mb-1" name="Omma License Number" />
            <span class="text-danger text-sm" v-show="errors.has('Omma License Number')">{{ errors.first('Omma License Number') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Email <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-mail" v-model="form.email" icon-pack="feather" class="w-full mb-1" name="Email" v-validate="'required|email'" />
            <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Role <span class="text-danger">*</span></label>
            <select-2
              autocomplete
              class="w-full"
              :value="form.roleId"
              @input="(item) => (form.roleId = item && item.value)"
              label-placeholder="Role"
              name="Role"
              placeholder="Select Role"
              action="role/getRoleGroup"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Role')">{{ errors.first('Role') }}</span>
          </div>

          <div class="vx-row mb-1" v-if="form.roleId === roles.LABADMIN">
            <label for="">Lab</label>
            <select-2
              class="w-full"
              autocomplete
              :value="form.labId"
              @input="(item) => (form.labId = item && item.value)"
              placeholder="Please Select Lab"
              name="Lab"
              :options="labOptions"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('Lab')">{{ errors.first('Lab') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Password <span class="text-danger">*</span></label>
            <vs-input v-validate="'required|min:6'" type="password" name="Password" icon="icon icon-lock" icon-pack="feather" v-model="form.password" class="w-full mb-1" ref="password" />
            <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
          </div>

          <div class="vx-row mb-1">
            <label for="">Confirm password <span class="text-danger">*</span></label>
            <vs-input
              v-validate="'required|min:6|confirmed:password'"
              type="password"
              name="Confirm Password"
              icon="icon icon-lock"
              icon-pack="feather"
              v-model="form.confirmPassword"
              class="w-full mb-1"
            />
            <span class="text-danger text-sm">{{ errors.first('Confirm Password') }}</span>
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button class="float-right mr-5 vs-con-loading__container" id="add-user-button" type="relief" @click="save_changes" :disabled="!validateForm || loading">Add User</vs-button>
            <vs-button to="/users/list" color="danger" type="relief" class="float-right">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Select2 from '@/components/custom/form-elements/Select2.vue'

import roleOptions from '@/utils/role_options'

export default {
  name: 'CreateUser',
  data: () => ({
    form: {
      username: '',
      password: '',
      firstname: '',
      lastname: '',
      mobile: '',
      email: '',
      state: '',
      roleId: null,
      cityId: null,
      metrcKey: '',
      address: '',
      zipcode: '',
      labId: null,
      omma_license_number: '',
      business_name: '',
      confirmPassword: ''
    },
    labOptions: []
  }),

  async mounted() {
    await this.get_lab_list()
  },

  methods: {
    ...mapActions('lab', { getLabList: 'getLabList' }),

    async get_lab_list() {
      try {
        const { data } = await this.getLabList({ page: 1, limit: 0 })
        this.labOptions = data.map((i) => ({
          ...i,
          label: i.name,
          value: i.id
        }))
      } catch (error) {}
    },

    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }
      this.$store
        .dispatch('user/insert', this.form)
        .then(() => {
          this.$router.push('/users/list')

          this.$vs.notify({
            title: 'Success',
            text: 'User created successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  computed: {
    ...mapState('user', ['loading']),
    ...mapState('auth', ['user']),
    ...mapState('permission', ['roles']),
    validateForm() {
      return !this.errors.any()
    },
    roleOptions() {
      return roleOptions.filter((role) => role.access.includes(this.user.roleId)).map(({ id, label }) => ({ value: id, label }))
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add-user-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-user-button > .con-vs-loading')
      }
    }
  },
  components: {
    Select2
  }
}
</script>
